import React from "react";
import { useTranslation } from "react-i18next";
import Button from "react-bootstrap/Button";

const BookmarksPanel = ({ bookmarks, onRemove, onClose, onNavigate }) => {
  const { t } = useTranslation();

  // Tipos de elementos que se pueden marcar
  const typeLabels = {
    prayer: { label: t('bookmarks.type_prayer'), icon: '🙏' },
    commandment: { label: t('bookmarks.type_commandment'), icon: '📜' },
    sin: { label: t('bookmarks.type_sin'), icon: '✝️' },
    saint: { label: t('bookmarks.type_saint'), icon: '👼' }
  };

  const handleBookmarkClick = (bookmark) => {
    if (onNavigate) {
      onNavigate(bookmark);
    }
    onClose();
  };

  return (
    <>
      <div className="bookmarks-overlay" onClick={onClose} />
      <div className="bookmarks-panel">
        <div className="bookmarks-header">
          <h2>{t('bookmarks.title')}</h2>
          <Button variant="link" onClick={onClose} aria-label="Close">
            ✕
          </Button>
        </div>

        {bookmarks.length === 0 ? (
          <div className="bookmarks-empty">
            <p>{t('bookmarks.empty')}</p>
          </div>
        ) : (
          <div className="bookmarks-list">
            {bookmarks.map((bookmark) => (
              <div key={bookmark.id} className="bookmark-item">
                <div
                  className="bookmark-info"
                  onClick={() => handleBookmarkClick(bookmark)}
                  style={{ cursor: onNavigate ? 'pointer' : 'default' }}
                >
                  <div className="bookmark-title">
                    {typeLabels[bookmark.type]?.icon || '📌'} {bookmark.title}
                  </div>
                  <div className="bookmark-type">
                    {typeLabels[bookmark.type]?.label || bookmark.type}
                    {bookmark.subtitle && ` • ${bookmark.subtitle}`}
                  </div>
                </div>
                <div className="bookmark-actions">
                  <Button
                    variant="link"
                    size="sm"
                    onClick={() => onRemove(bookmark.id)}
                    aria-label={t('bookmarks.remove')}
                  >
                    🗑️
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}

        {bookmarks.length > 0 && (
          <div className="bookmarks-footer mt-3 pt-3 border-top">
            <Button
              variant="outline-danger"
              size="sm"
              onClick={() => {
                if (window.confirm(t('bookmarks.clear_confirm'))) {
                  bookmarks.forEach(b => onRemove(b.id));
                }
              }}
            >
              {t('bookmarks.clear_all')}
            </Button>
          </div>
        )}
      </div>
    </>
  );
};

export default BookmarksPanel;
